/* GASSISA
=========================================================================================
* Descripción: Puente neutro entre SesionContext y RequestContext para recuperación 401.
*              SesionContext registra su refreshSession() single-flight y su
*              handleClickCerrarSesion(); RequestContext los consume sin importar
*              SesionContext (evita dependencia circular Sesion<->Request).
*              Este módulo no implementa refresh ni logout propios: solo referencias.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 22/09/2026 | Lic. José Luis Aragón Cervantes  | Creación: puente 401-refresh-retry
* ---------------------------------------------------------------------------------------
*/

let sessionRefreshHandler = null;
let sessionLogoutHandler = null;

export const registerSessionHandlers = ({ refresh, logout } = {}) => {
  if (typeof refresh === "function") sessionRefreshHandler = refresh;
  if (typeof logout === "function") sessionLogoutHandler = logout;
};

export const getSessionRefresh = () => sessionRefreshHandler;
export const getSessionLogout = () => sessionLogoutHandler;

// La propia petición de refresh nunca entra al mecanismo retry-401 (anti-recursión).
export const isSessionRefreshRequest = (url = "") =>
  typeof url === "string" && url.includes("/TenantSeguridad/RefreshToken");
